import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { SingleSelectQuestionTemplateStyles as S } from '~/pages/anatomyV2/libs/components/SingleSelectQuestionTemplate/styles'
import { ITextOption } from '~/pages/anatomyV2/libs/components/TextOptionsQuestionTemplate/constants'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

interface ISingleSelectQuestionTemplateProps extends TPageProps {
  currentSection: number
  titleI18nKey: string
  options: ITextOption[]
  question: string
}

const SingleSelectQuestionTemplate = ({
  pageId,
  nextPagePath,
  currentSection,
  titleI18nKey,
  options,
  question,
}: ISingleSelectQuestionTemplateProps) => {
  useMatchHeaderBackground()

  const { t } = useTranslation('anatomyV2')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <SectionProgress currentSection={currentSection} pageId={pageId} />

        <S.Title>
          <Trans ns="anatomyV2" i18nKey={titleI18nKey} />
        </S.Title>

        <S.Options>
          {options.map(({ key, i18nKey }) => (
            <S.OptionButton
              key={key}
              type="button"
              $isSelected={answer === key}
              disabled={isAnswersDisabled}
              onClick={() => {
                setAnswer(key)
                handleChange(key, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              {t(i18nKey)}
            </S.OptionButton>
          ))}
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default SingleSelectQuestionTemplate
